import React, { useState, useEffect } from "react";
import { Modal, Popconfirm, Upload, Button } from "antd";
import { withUser } from "pages/context/user";
import {
  staffOut,
  completeCustomerInfo,
  checkWxOut,
  unbindingWeixin
} from "apis/user";
import { baseUrl, showMessage } from "utils";
import { getToken, userLogout } from "pages/myutils/user";
import { validatePureNumber } from "components/common";
import $ from "jquery";
import * as qs from "query-string";
import cookies from "js-cookie";
import CommonIcon from "pages/components/commonIcon";

const AlertFn = withUser(function StaffList({
  user,
  visible,
  onClose,
  openPasAlert,
  openbindPhoneAlert,
  openChangeNameeAlert,
  wx
}) {
  const { companyid } = qs.parse(window.location.search);
  const [role, token] = getToken();
  const { self } = user;
  const [img, setImg] = useState(
    self.photo || self.weixinHeadimgurl || "/img/user-small.png"
  );
  const [getWxBol, setWxBol] = useState(false);
  const handleChange = info => {
    if (info.file.status === "done") {
      completeCustomerInfo({ photo: info.file.response }).then(() => {
        showMessage("success", "修改成功！");
        setImg(info.file.response);
        user.dispatch({ type: "init" });
      });
    }
  };
  useEffect(() => {
    checkWxOut().then(data => {
      setWxBol(data);
    });
  }, []);
  return (
    <Modal
      title="个人信息"
      closable
      onCancel={onClose}
      visible={visible}
      footer={false}
      width={800}
      className="userInfoAleft"
    >
      <div className="infoBox clearFix">
        <div className="leftBox left">
          <CommonIcon self={self} className="infoTx" />
          <br />
          {/* <img className="infoTx" alt="userpicture" src={img} /> */}
          <Upload
            name="file"
            showUploadList={false}
            action={`${baseUrl}/fileStorage/uploadFile`}
            data={{ token }}
            onChange={handleChange}
          >
            <Button type="primary" ghost style={{ marginTop: 30 }}>
              修改头像
            </Button>
          </Upload>
        </div>
        <div className="rightBox right">
          <div className="textBox">
            <span>当前企业：</span>
            <span
              title={
                self.company && self.company.companyName
                  ? self.company.companyName
                  : "无"
              }
            >
              {self.company && self.company.companyName
                ? self.company.companyName
                : "无"}
            </span>
            {/* <Popconfirm
              title="退出企业后，你将不再拥有该企业相关服务的使用权限，且此操作不可逆！"
              onConfirm={() => {
                staffOut(self.company.staffId).then(() => {
                  Modal.success({
                    title: "提示",
                    content: `退出成功,请重新登录`,
                    onOk: () => {
                      userLogout();
                      window.location.href = "/login";
                    }
                  });
                });
              }}
              okText="确定退出"
              cancelText="取消"
            >
              {self.company && <a href="javaScript:;">退出企业</a>}
            </Popconfirm> */}
            <Popconfirm
              title="退出企业后，你将不再拥有该企业相关服务的使用权限，且此操作不可逆！"
              onConfirm={() => {
                // 返回data是否是当前企业companyid判断
                $.ajax({
                  url:
                    baseUrl +
                    `/customer/styleCompanyId?token=${token ||
                      cookies.get("shorcuts")}`,
                  async: false,
                  withCredentials: true,
                  success: data => {
                    if (data > 0) {
                      const companyids = data;
                      staffOut(self.company.staffId).then(() => {
                        Modal.success({
                          title: "提示",
                          content: `退出成功,请重新登录`,
                          onOk: () => {
                            userLogout();
                            // 清除companyid
                            cookies.remove("jiluCompanyid");
                            window.location.href = `/login?companyid=${companyids}`;
                          }
                        });
                      });
                    } else {
                      staffOut(self.company.staffId).then(() => {
                        Modal.success({
                          title: "提示",
                          content: `退出成功,请重新登录`,
                          onOk: () => {
                            userLogout();
                            // 清除companyid
                            cookies.remove("jiluCompanyid");
                            window.location.href = "/login";
                          }
                        });
                      });
                    }
                  }
                });
              }}
              okText="确定退出"
              cancelText="取消"
            >
              {self.company && <a href="javaScript:;">退出企业</a>}
            </Popconfirm>
          </div>

          <div className="textBox">
            <span>用户昵称：</span>
            <span>
              {self.name ||
                self.weixinNickName ||
                (validatePureNumber(self.username) ? "" : self.username)}
            </span>
            <a href="javaScript:;" onClick={openChangeNameeAlert}>
              修改
            </a>
          </div>
          {self.phoneBinding && (
            <div className="textBox">
              <span>登录密码：</span>
              <a
                href="javaScript:;"
                style={{ marginLeft: 0 }}
                onClick={openPasAlert}
              >
                修改
              </a>
            </div>
          )}

          <div className="textBox">
            <span>绑定手机号：</span>
            <span>{self.phone}</span>
            <a href="javaScript:;" onClick={openbindPhoneAlert}>
              {self.phoneBinding ? "修改" : "去绑定"}
            </a>
          </div>
          <div className="textBox">
            <span>绑定微信号：</span>
            <span>{self.weixinBinding && self.weixinNickName}</span>
            {self.weixinBinding && getWxBol && (
              <Popconfirm
                title="解绑微信后，你将不再通过微信登录该账号，解绑后可重新绑定。"
                onConfirm={() => {
                  unbindingWeixin().then(() => {
                    showMessage("success", "解绑成功！");
                    user.dispatch({ type: "init" });
                  });
                }}
                okText="确定解绑"
                cancelText="取消"
              >
                <a href="javaScript:;">解除绑定</a>
              </Popconfirm>
            )}
            {self.weixinBinding && !self.phoneBinding && (
              <p className="gray-font" style={{ marginTop: 20 }}>
                微信号注册的账号，未绑定手机时不支持解绑微信
              </p>
            )}
            {!self.weixinBinding && (
              <a
                href="javaScript:;"
                onClick={() => {
                  wx();
                  onClose();
                }}
                style={{ marginLeft: 0 }}
              >
                绑定微信
              </a>
            )}
            <p />
          </div>
        </div>
      </div>
    </Modal>
  );
});

export default AlertFn;
